//ErrorHandler, APP_INITIALIZER
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { NZ_I18N } from 'ng-zorro-antd/i18n';
import { en_US } from 'ng-zorro-antd/i18n';
import { registerLocaleData } from '@angular/common';
import en from '@angular/common/locales/en';
import { FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { SharedModule } from 'src/@shared/shared/shared.module';
import { AuthGuard } from 'src/@shared/shared/auth.guard';
import { SwitchAcComponent } from './switch-ac/switch-ac.component';
import { ProfileMenuModule } from './pages/common-layout/account-settings/profile-menu/profile-menu.module';
import { ErrorpageComponent } from './errorpage/errorpage.component';
import { CodeInputModule } from 'angular-code-input';
import { SiteUnderMaintenanceComponent } from './site-under-maintenance/site-under-maintenance.component';
import { HTTP_INTERCEPTORS } from '@angular/common/http';

// import * as Sentry from "@sentry/angular-ivy";
// import { Router } from "@angular/router";
import { AuthInterceptorService } from './auth-interceptor.service';
import {
  ATTACHMENT_PREVIEW_PROVIDER,
  AUTH_TOKEN_PROVIDER,
  LOCAL_STORAGE_PORT,
  LocalStorageAdapter,
  PaymentsAttachmentPreviewAdapter,
  BrowserReportDownloadAdapter,
  REPORT_DOWNLOAD_PROVIDER,
  SESSION_STORAGE_PORT,
  SessionAuthTokenProviderAdapter,
  SessionStorageAdapter,
} from 'src/@shared/shared/providers';

registerLocaleData(en);

@NgModule({
  declarations: [
    AppComponent,
    SwitchAcComponent,
    ErrorpageComponent,
    SiteUnderMaintenanceComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    ProfileMenuModule,
    FormsModule,
    HttpClientModule,
    BrowserAnimationsModule,
    SharedModule,
    CodeInputModule,
  ],
  providers: [
    AuthGuard,
    { provide: NZ_I18N, useValue: en_US },
    // {
    //   provide: ErrorHandler,
    //   useValue: Sentry.createErrorHandler({
    //     showDialog: false,
    //   }),
    // },
    // {
    //   provide: Sentry.TraceService,
    //   deps: [Router],
    // },
    // {
    //   provide: APP_INITIALIZER,
    //   useFactory: () => () => {},
    //   deps: [Sentry.TraceService],
    //   multi: true,
    // },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptorService,
      multi: true,
    },
    {
      provide: AUTH_TOKEN_PROVIDER,
      useExisting: SessionAuthTokenProviderAdapter,
    },
    {
      provide: LOCAL_STORAGE_PORT,
      useExisting: LocalStorageAdapter,
    },
    {
      provide: SESSION_STORAGE_PORT,
      useExisting: SessionStorageAdapter,
    },
    {
      provide: ATTACHMENT_PREVIEW_PROVIDER,
      useExisting: PaymentsAttachmentPreviewAdapter,
    },
    {
      provide: REPORT_DOWNLOAD_PROVIDER,
      useExisting: BrowserReportDownloadAdapter,
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {
  constructor() { }
}
